import script from "./StreetName.vue?vue&type=script&setup=true&lang=js"
export * from "./StreetName.vue?vue&type=script&setup=true&lang=js"

import "./StreetName.vue?vue&type=style&index=0&id=62d0c6de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62d0c6de"]])

export default __exports__